<script lang="ts">
    import cn from 'classnames';

    import type { DataAttrs } from '@uikit/types';
    import { Font, FontTypes } from '@uikit/font';
    import { SvgIcon, SvgIconTypes } from '@uikit/svg-icon';

    import s from './select-option.module.css';
    import type { ClickHandlerFn } from './types';
    import { Avatar, AvatarTypes } from '@uikit/avatar';

    export let label: string;
    export let decoratedLabel: NullableString = undefined;
    export let value: NullableString = undefined;
    export let img: NullableString = undefined;
    export let icon: NullableType<SvgIconTypes.IconData> = undefined;
    export let suffixText: NullableString = undefined;
    export let classes: NullableString = undefined;
    export let clickHandler: NullableType<ClickHandlerFn> = undefined;
    export let attrs: Partial<DataAttrs> = {};
    export let isLabelImg: boolean = false;

    const iconWidth = 28;
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<li class={cn(s.container, classes)} on:click={clickHandler && (() => clickHandler && clickHandler(value))} {...attrs}>
    <div class={s.leftPart}>
        <slot name="prefix" />

        {#if img || isLabelImg}
            <Avatar size={AvatarTypes.Size.semiSmall} userName={label} userId={4} thumbUrl={img} />
        {/if}

        {#if icon}
            <SvgIcon width={iconWidth} {icon} />
        {/if}
        <Font type={FontTypes.Type.body} className={s.label}>
            {@html decoratedLabel ?? label}
        </Font>
    </div>
    <div class={s.rightPart}>
        {#if suffixText}
            <Font type={FontTypes.Type.caption} color={FontTypes.Color.Secondary}>
                {suffixText}
            </Font>
        {/if}
        <slot name="suffix" />
    </div>
</li>
